// Copyright (c) Docugami, Inc. All rights reserved.

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
} from 'chart.js';
import { primaryTheme } from 'components/shell/presentation/AppStyles';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip
);

interface LineChartProps {
    data: number[];
    title: string;
    label: string;
}

export const LineChart = (props: LineChartProps): JSX.Element => {
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: props.title,
            },
        },
    };

    const data = {
        labels: props.data.map((v, i) => ""),
        datasets: [
            {
                label: props.label,
                data: props.data.map((v, i) => v.toFixed(0)),
                borderColor: primaryTheme.palette.themePrimary,
                backgroundColor: primaryTheme.palette.themePrimary,
            },
        ],
    };

    return <Line options={options} data={data} />;;
};
